export default __webpack_public_path__ + "assets/process-4.c260d6ea.gif";